import { CoreExecutorType, getCoreType } from '@/common/constants/core'
import { createSafeClientData } from '@/services/core/core.service'
import { useAppStore } from '@/stores/app'

export function createPlatformActionParams(params: any) {
  // Если есть вложенный params - извлекаем его и мержим с корневыми полями
  let effectiveParams = { ...params }

  if (params.params && typeof params.params === 'object') {
    const { params: nestedParams, ...rootParams } = params
    effectiveParams = { ...rootParams, ...nestedParams }
  }

  const defaultParams = {
    sessionId: null,
    isClone: false,
    type: getCoreType() || CoreExecutorType.WF,
    actionType: 1,
    actionId: '',
    clientData: createSafeClientData(),
    formState: {
      params: {},
      openPage: null
    },
    fids: [],
    currentFid: null,
    openingParams: {
      newWindow: false,
      ignoreExistingStack: false,
      tempFid: null
    }
  }

  const result = deepMerge(defaultParams, effectiveParams)

  try {
    const appStore = useAppStore()
    const ignoreStack = result.openingParams?.ignoreExistingStack === true
    const storeFids = Array.isArray(appStore.formStackFids)
      ? appStore.formStackFids
      : []
    if (
      !ignoreStack &&
      (!effectiveParams?.fids || effectiveParams.fids.length === 0) &&
      storeFids.length
    ) {
      result.fids = [...storeFids]
    }

    const storeCurrentFid = typeof appStore.currentFormFid === 'string'
      ? appStore.currentFormFid
      : null
    if (!ignoreStack && !result.currentFid && storeCurrentFid) {
      result.currentFid = storeCurrentFid
    }
  } catch (error) {
    console.debug('[requestSanitizer] Unable to derive form stack from store', error)
  }

  // ГАРАНТИРУЕМ, что clientData не null и правильно структурирован
  if (result.clientData === null || typeof result.clientData !== 'object') {
    result.clientData = createSafeClientData()
  } else {
    // Если clientData передан, но не в правильном формате, используем createSafeClientData для нормализации
    result.clientData = createSafeClientData(result.clientData)
  }

  // УБИРАЕМ ВЛОЖЕННЫЙ PARAMS ЕСЛИ ОН ЕСТЬ
  if (result.params) {
    delete result.params
  }
  // Middle `UserSession.getCoreFromRequest` не читает cloneOf — не кладём в /platform/action.
  delete result.cloneOf
  return result
}

function deepMerge(target: any, source: any): any {
  if (source === null || typeof source !== 'object') {
    return target
  }

  const result = { ...target }

  Object.keys(source).forEach(key => {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      result[key] = deepMerge(result[key] || {}, source[key])
    } else if (source[key] !== undefined && source[key] !== null) {
      result[key] = source[key]
    }
  })

  return result
}
